export default "__VITE_ASSET__CMm$tzUd__"